/**
 * WD Featured Collection Swiper
 * Loads Swiper 11 from CDN once per page, then initializes carousel roots that are not yet initialized.
 */

(function () {
  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  function ensureSwiperAssets() {
    if (typeof window.Swiper === 'function') {
      return Promise.resolve();
    }

    if (window.__wdFcSwiperAssetsPromise) {
      return window.__wdFcSwiperAssetsPromise;
    }

    window.__wdFcSwiperAssetsPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-wd-fc-swiper-cdn]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        link.setAttribute('data-wd-fc-swiper-cdn', '');
        document.head.appendChild(link);
      }

      var script = document.querySelector('script[data-wd-fc-swiper-cdn]');

      function onSwiperReady() {
        window.__wdFeaturedCollectionsSwiperLoaded = true;
        resolve();
      }

      if (!script) {
        script = document.createElement('script');
        script.src = SWIPER_JS;
        script.setAttribute('data-wd-fc-swiper-cdn', '');
        script.onload = onSwiperReady;
        script.onerror = function () {
          window.__wdFcSwiperAssetsPromise = null;
          reject(new Error('Failed to load Swiper'));
        };
        document.head.appendChild(script);
        return;
      }

      if (typeof window.Swiper === 'function') {
        onSwiperReady();
        return;
      }

      script.addEventListener('load', onSwiperReady, { once: true });
      script.addEventListener(
        'error',
        function () {
          reject(new Error('Failed to load Swiper'));
        },
        { once: true }
      );
    });

    return window.__wdFcSwiperAssetsPromise;
  }

  function initOneRoot(carousel) {
    if (carousel.getAttribute('data-wd-fc-swiper-initialized') === 'true') {
      return;
    }

    var swiperContainer = carousel.querySelector('.wd-fc-swiper');
    var prevButton = carousel.querySelector('.wd-fc-swiper-next');
    var nextButton = carousel.querySelector('.wd-fc-swiper-prev');


    if (!swiperContainer) return;

    carousel.setAttribute('data-wd-fc-swiper-initialized', 'true');

    var mobileSlides = parseInt(carousel.getAttribute('data-mobile-slides'), 10) || 1;
    var desktopSlides = parseInt(carousel.getAttribute('data-desktop-slides'), 10) || 4;
    var spaceMobile = parseInt(carousel.getAttribute('data-space-mobile'), 10) || 16;
    var spaceDesktop = parseInt(carousel.getAttribute('data-space-desktop'), 10) || 24;
    var isAutoplay = carousel.getAttribute('data-autoplay') === 'true';

    var viewMobile = mobileSlides + 0.75;
    var viewDesktop = desktopSlides + 0.2;

    var totalSlides = swiperContainer.querySelectorAll('.swiper-slide').length;
    var shouldLoop = totalSlides > Math.ceil(viewDesktop);

    var swiperConfig = {
      slidesPerView: viewMobile,
      spaceBetween: spaceMobile,
      slidesPerGroup: 1,
      loop: shouldLoop,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        741: {
          slidesPerView: desktopSlides > 2 ? desktopSlides - 1 + 0.2 : viewDesktop,
          spaceBetween: spaceDesktop,
        },
        1000: {
          slidesPerView: viewDesktop,
          spaceBetween: spaceDesktop,
        },
      },
    };

    if (isAutoplay) {
      swiperConfig.autoplay = {
        delay: 4000,
        disableOnInteraction: false,
      };
    }

    new window.Swiper(swiperContainer, swiperConfig);
  }

  function initAllRoots() {
    document.querySelectorAll('[data-wd-fc-swiper-root]').forEach(initOneRoot);
  }

  function boot() {
    ensureSwiperAssets()
      .then(initAllRoots)
      .catch(function (err) {
        if (typeof console !== 'undefined' && console.error) {
          console.error(err);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
